import UnclaimedDraftEmbeddedSigning from "components/lib/Shared/ESignature/UnclaimedDraftEmbeddedSigning";
import { useSelector, useDispatch } from "react-redux";
import { convertOfficialDetailsToSignerDetails } from "utils/esignature";
import { updateCompanyAsync } from "state/slices/company";
import { useEffect, useState } from "react";

const SecondStep = ({
  isShareholdersOnlyFormsUploaded,
  setIsShareholdersOnlyFormsUploaded,
  handleBackBtn,
  isFirstStepComplete,
  shareholders,
}) => {
  const dispatch = useDispatch();
  /** These are the officials that will be sent the emails to sign a document electronically */
  const companyOfficials = useSelector(
    (state) => state.companyOfficialsSlice.companyOfficials.items
  );
  const { company } = useSelector((state) => state.companySlice);

  const [signers, setSigners] = useState([]);

  const shareholdersOnlyForms = Object.keys(company.preSignedBusinessDocuments)
    .filter((key) => key === "formCR2" || key === "articlesOfAssociation")
    .reverse();

  const fileUrls = shareholdersOnlyForms.map(
    (form) =>
      `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${company.preSignedBusinessDocuments[form]}`
  );

  const disableTab = () => {
    setIsShareholdersOnlyFormsUploaded(true);
  };

  const updateCompanyStatusToSignature = () => {
    dispatch(
      updateCompanyAsync({
        id: company._id,
        data: { status: "Signature", agreeToSubmit: true },
      })
    );
  };

  let functionsToCall = [disableTab];

  if (isFirstStepComplete) {
    functionsToCall.push(updateCompanyStatusToSignature, handleBackBtn);
  }

  const metadata = {
    fileNames: shareholdersOnlyForms,
    isShareholdersOnlyEmail: true,
    companyId: company._id,
  };

  useEffect(() => {
    if (shareholders.length > 0) {
      const applicant = convertOfficialDetailsToSignerDetails(
        company?.createdBy
      );
      shareholders = shareholders.map((details) =>
        convertOfficialDetailsToSignerDetails(details)
      );
      const isApplicantOfficial = shareholders.find(
        (signer) =>
          signer.name === applicant.name &&
          signer.emailAddress === applicant.emailAddress
      );

      if (!isApplicantOfficial) {
        setSigners([applicant, ...shareholders]);
      } else {
        setSigners([...shareholders]);
      }
    }
  }, [shareholders]);

  if (isShareholdersOnlyFormsUploaded === true) {
    return (
      <div>
        <h1>You have already uploaded Shareholders only forms</h1>
      </div>
    );
  } else if (signers.length > 0) {
    if (isFirstStepComplete) {
      return (
        <div>
          <UnclaimedDraftEmbeddedSigning
            signers={signers}
            fileUrls={fileUrls}
            metadata={metadata}
            functionsToCall={functionsToCall}
          />
        </div>
      );
    } else {
      return (
        <div>
          <h1>You need to upload Directors only forms</h1>
        </div>
      );
    }
  } else {
    return <div>Getting signers.....</div>;
  }
};

export default SecondStep;
